import EnumDropdown, { getItemsFromEnum } from '@/components/EnumDropdown';

import { DropdownProps } from '@/components/Dropdown';
import { LostAndFoundIssueWithCacheReturnStatusEnum } from '@/models/gen/graphql';
import { fieldWrapper } from '@/components/Field';

export type ReturnStatusDropdownProps = Omit<DropdownProps, 'items'>;
const ReturnStatusDropdown = ({ ...dropdownProps }: ReturnStatusDropdownProps): JSX.Element => (
  <EnumDropdown
    {...dropdownProps}
    enum={getItemsFromEnum(LostAndFoundIssueWithCacheReturnStatusEnum)}
    options={{
      locale: {
        'Select...': 'Select Return Status',
        ReportedLost: 'Reported Lost',
        Unclaimed: 'Unclaimed',
        Reportedlost: 'Reported Lost',
      },
    }}
  />
);
export const ReturnStatusDropdownField = fieldWrapper<ReturnStatusDropdownProps>(ReturnStatusDropdown);
export default ReturnStatusDropdown;
